(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["epic-launch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('epic-product-wheel')) {
  customElements.define('epic-product-wheel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('.epic-wheel-slide')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelector('.epic-wheel-controls').hidden = false;
      this.toggle = this.querySelector('[data-pause]');
      const step = (delta) => {
        this.slides[this.index].hidden = true;
        this.index = (this.index + delta + this.slides.length) % this.slides.length;
        this.slides[this.index].hidden = false;
        this.querySelector('[data-count]').textContent = `${this.index + 1} / ${this.slides.length}`;
      };
      const label = () => {
        this.toggle.textContent = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
        this.toggle.setAttribute('aria-pressed', String(this.paused));
      };
      this.querySelector('[data-prev]').onclick = () => { this.paused = true; label(); step(-1); };
      this.querySelector('[data-next]').onclick = () => { this.paused = true; label(); step(1); };
      this.toggle.onclick = () => { this.paused = !this.paused; label(); };
      label();
      this.timer = setInterval(() => {
        if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) step(1);
      }, 4500);
    }
    disconnectedCallback() { clearInterval(this.timer); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
